// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"AudioLoading_loadingWrapper__sokl5","lottieLoader":"AudioLoading_lottieLoader__i01lx","loadingText":"AudioLoading_loadingText__CmLik"};